module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_2048.ad67fa23.jpg";